// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"78c65dc5","170":"9b900e91","370":"75202c7c","910":"27940bda","927":"205adbe3","936":"053be445","982":"89d9275e"}[chunkId] + ".chunk.js";
};